import { render } from "./ResultDisplay.vue?vue&type=template&id=61fe6c34&scoped=true"
import script from "./ResultDisplay.vue?vue&type=script&lang=js"
export * from "./ResultDisplay.vue?vue&type=script&lang=js"

import "./ResultDisplay.vue?vue&type=style&index=0&id=61fe6c34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fe6c34"]])

export default __exports__